import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrObejctIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M22.03 5.63L12.5 0.129995C12.19 -0.0500049 11.81 -0.0500049 11.5 0.129995L1.97 5.63C1.66 5.81 1.47 6.14 1.47 6.5V17.5C1.47 17.86 1.66 18.19 1.97 18.37L11.5 23.87C11.81 24.05 12.19 24.05 12.5 23.87L22.03 18.37C22.34 18.19 22.53 17.86 22.53 17.5V6.5C22.53 6.14 22.34 5.81 22.03 5.63ZM12 2.15L19.53 6.5L12 10.85L4.47 6.51L12 2.16V2.15ZM3.47 8.22999L11 12.57V21.26L3.47 16.91V8.22V8.22999ZM13 21.27V12.58L20.53 8.24V16.93L13 21.28V21.27Z" fill={color}/>
  </BaseIcon>
));

AttrObejctIcon.displayName = 'AttrObejctIcon';
